//---- components ---------
//---- mixins -------------
//---- services -----------
import authService from '../services/auth.service.js';
import BrowserTabService from '../services/browser-tab.service.js'
import KMOfflineService from "@/app/services/kmoffline.service.js";
import notifications from '../services/notification.js';
import projectHomeService from '../services/projectHome.service.js';
//---- other --------------
//---- 3rd-parties --------

export const initialState = {
  headerData: '',
  currentLocale: null,
  isActiveTab: true,
  kmOfflineDownloadStatus: ""
}

export const header = {
  namespaced: true,

  state: { ...initialState }, // copy initial state

  actions: {
    update({ commit }, headerData) {
      commit('setHeader', headerData);
    },

    onLogout({ commit }) {
      BrowserTabService.onLogout()
      commit('onLogout');
    },

    onTimeout({ commit }) {
      BrowserTabService.onLogout()
      commit('onLogout');
    },

    async changeLocale({ commit }, localeCode) {
      await projectHomeService.switchLocale(localeCode)
      commit('changeLocale', localeCode);
      return Promise.resolve(localeCode);
    },

    setLocale({ commit }, localeCode) {
      commit('changeLocale', localeCode);
    },

    // reload the header information from the backend
    async reload({ commit }) {
      let response = await authService.reloadHeader();
      if (response?.data?.header) {
        await commit('setHeader', response.data.header)

        await commit('projectData/setProfiles', response.data?.header?.profiles || [], { root: true })
        if (response.data.skinProperties)
          await commit('projectData/setSkinProperties', response.data.skinProperties || [], { root: true })
      }
      if (response?.data?.soloStatus)
          commit("kmOffline/updateStatus", response.data.soloStatus, { root: true });

      return Promise.resolve(response);
    },
    
    initIsActiveTab({ commit }) {
      const isActiveTab = BrowserTabService.isActiveTab()
      commit('setIsActiveTab', isActiveTab)
      return isActiveTab
    },
    setIsActiveTab({ commit, state }, isActiveTab) {
      if (isActiveTab != state.isActiveTab)
        commit('setIsActiveTab', isActiveTab)
    },
    makeCurrentTabActive({ commit }) {
      commit('setIsActiveTab', BrowserTabService.makeCurrentTabActive())
    },
    generateKMOfflinePackage({ commit }, params) {
      return KMOfflineService.generateKMOfflinePackage(params).then(response => {
        if (response.data)
          commit('setSoloDownloadStatus', response.data.status)
        return Promise.resolve(response);
      })
    }
  },

  mutations: {
    setHeader(state, headerData) {
      state.headerData = headerData;
      state.currentLocale = headerData.currentLocale;
    },
    onLogout(state) {
      state.headerData = {}
    },
    changeLocale(state, localeCode) {
      if (typeof state?.header?.locales === 'undefined')
        return
      // find the locale that matches the localeCode and set it as the current locale
      const newLocale = state.headerData.locales.find(item => item.code === localeCode);
      if (newLocale === null) {
        notifications.warn("Could not switch to locale " + localeCode)
        return
      }

      state.currentLocale = newLocale
    },
    setIsActiveTab(state, isActiveTab) {
      state.isActiveTab = isActiveTab
    },
    setSoloDownloadStatus(state, status) {
      state.kmOfflineDownloadStatus = status
    }
  },
  getters: {
    // ...
    loggedIn: (state, getters) => {
      return !!getters.userId
    },
    userId: (state) => {
      return state.headerData && state.headerData.user && state.headerData.user.userId
    },
    userProperties: (state) => {
      return state.headerData?.user?.userProperties
    },
    locales: (state) => {
      return state.headerData && state.headerData.locales
    },
    currentLocale: (state) => {
      return state.currentLocale
    },
    projects: (state) => {
      // // if no projects, try to fetch list from backend
      // if (!state.headerData.projects || state.headerData.projects.length == 0)
      //   // ;
      return (state.headerData && state.headerData.projects) || []
    },
    currentProject: (state) => {
      let currProject;
      state.headerData?.projects?.forEach(element => {
        if (element.isCurrentProject)
          currProject = element;
      });
      return currProject;
    },
    showProjectSelectionPage: (state, getters) => {
      return getters.projects.length > 1
    },
    tools: (state) => {
      return (state.headerData && state.headerData.tools) || []
    },
    isActiveTab(state) {
      return state.isActiveTab
    },
    currentSkin: (state) => {
      return state.headerData?.skin
    }
  }
};